import React, { useEffect, useState } from "react";
import helpers from "helpers/base";
import RealPaypalButton from "./PaypalButton";
import { reactivateRequests } from "./requests";

export function PaypalReactivationForm(props) {
  const { paypalEnvironment, requests, subscriptionType, PaypalButton } = props;

  const [paypalActions, setPaypalActions] = useState({});
  const [paypalErrorMessage, setPaypalErrorMessage] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [paypalProcessing, setPaypalProcessing] = useState(false);

  const clearErrorMessages = () => setPaypalErrorMessage(null);

  useEffect(() => {
    window.subscriptionType = subscriptionType;
  }, []);

  useEffect(() => {
    if (paypalActions.enable) {
      paypalActions.enable();
    }
  }, [paypalActions]);

  const paypalHandlers = {
    onAuthorize: async (data) => {
      setPaypalProcessing(true);
      onSubmit({
        paypal_token: helpers.extractPaypalExpressCheckoutToken(data)
      });
    },
    onCancel: () => {
      setDisabled(false);
      setPaypalProcessing(false);
    },
    onClick: () => {
      clearErrorMessages();
    },
    onError: (error) => {
      const captures = error.message.match(/Error: (.*)/);
      setPaypalErrorMessage(captures[1]);
      setDisabled(false);
      setPaypalProcessing(false);
    },
    payment: async (resolve, reject) => {
      setDisabled(true);
      const response = await requests.createBillingAgreement();
      const data = await response.json();
      if (response.ok) {
        resolve(data.token);
      } else {
        reject(data.errorMessage);
      }
    },
    validate: (actions) => {
      setPaypalActions(actions);
    }
  };

  async function onSubmit(postData) {
    const response = await requests.createSubscription(postData);

    const finalDestination = response.headers.get("Location");

    if (response.ok) {
      window.location.assign(finalDestination);
    } else {
      // we only return JSON for errors
      const json = await response.json();
      setPaypalErrorMessage(json.errorMessage);
      paypalActions.enable();
      setDisabled(false);
      setPaypalProcessing(false);
      // [LE-1522] This code path is not in use. Trace path back and remove.
      window.LitCharts.trackEvent("payment-error", "paypal onSubscribeFailed", {
        extraData: {
          responseJSON: json
        }
      });
    }
  }

  return (
    <div className="paypal-reactivation-form">
      <PaypalButton
        environment={paypalEnvironment}
        processing={paypalProcessing}
        disabled={disabled}
        errorMessage={paypalErrorMessage}
        showSeparator={false}
        {...paypalHandlers}
      />
    </div>
  );
}

PaypalReactivationForm.defaultProps = {
  PaypalButton: RealPaypalButton
};

export default function (props) {
  return <PaypalReactivationForm {...props} requests={reactivateRequests} />;
}
